import type {
  TIndividualQuestionnaireForm,
  TInstitutionInformationForm,
  TInstitutionQuestionnaireForm,
  TKYCApiVersion,
} from "@adgm/cross-models";
import { Dimensions } from "react-native";

// 机构问卷表单默认值
export const INSTITUTION_QUESTIONNAIRE_FORM: TInstitutionQuestionnaireForm = {
  intendedDepositAmount: "",
  expectedTradeVolume: "",
  expectedAccountUtilization: [],
  fundingAccountOwnerName: "",
  fundingMethods: [],
  fundingSourceCountry: "",
  depositingInstitution: "",
  investmentProductTypes: [],
};

// 个人问卷表单默认值
export const INDIVIDUAL_QUESTIONNAIRE_FORM: TIndividualQuestionnaireForm = {
  personalInformation: {
    multipleNationalities: "",
    politicallyExposedPerson: "",
    annualIncome: "",
    liquidNetWorth: "",
  },
  investment: {
    yearsOfInvestmentExperience: null, // 注意这种复杂对象字段初始化一定为null,否则表单二次编辑填入数据会出问题
    numberOfInvestmentsLastFiveYear: null, // 注意这种复杂对象字段初始化一定为null,否则表单二次编辑填入数据会出问题
    productKnowledgeLevels: [],
    expectedInvestmentHoldingPeriod: "",
    expectedAccountUtilization: "",
    // investmentLossToleranceLevel: "",
  },
  supplement: {
    sourceOfFund: null, // 注意这种复杂对象字段初始化一定为null,否则表单二次编辑填入数据会出问题
    sourceOfWealth: null, // 注意这种复杂对象字段初始化一定为null,否则表单二次编辑填入数据会出问题
    accountFundingMethods: [],
    intendedDepositAmount: "",
    expectedTradingVolume: "",
    fundingSourceCountry: "",
    fundingSourceInstitution: "",
    desiredProductTypes: [],
    employmentStatus: "",
    employerName: "",
    employerCountry: "",
    fundingAccountOwnerName: "",
    employerIndustry: "",
  },
  professionalExperience: {
    linkedinProfile: "",
  },
  taxResidences: {
    taxCitizenFromUS: "",
    taxResidenceList: [],
  },
};

// 机构基础信息表单默认值
export const INSTITUTION_INFORMATION_FORM: TInstitutionInformationForm = {
  registration: {
    companyName: "",
    tradingName: "",
    incorporationDate: "",
    incorporationPlace: "",
    registeredAddress: "",
    mainBusinessAddress: "",
    legalForm: "",
  },
  operations: {
    commercialActivities: "",
    yearsInOperation: "",
    numberOfStaff: "",
    operatingCountries: [],
    mostRecentNetProfit: "",
    mostRecentNetAsset: "",
    financialYearForEstimates: "",
    // 因数据结构，以及选项选中的问题，listedEntity需要初始化为undefined
    listedEntity: undefined,
    uaeWhollyOwnedHolding: "",
    politicallyExposedStakeholders: "",
  },
  shareholders: [],
  // beneficiaries: [],
  owner: {
    beneficiaries: [],
    wealthSourceOfOwner: null, // 注意这种复杂对象字段初始化一定为null,否则表单二次编辑填入数据会出问题
  },
  // directorsOrAuthorisedSignatories
  directors: [],
  authorisedSignatories: [],
  mostSeniorAuthorisedSignatory: {
    name: "",
    yearsOfInvestmentExperience: null, // 注意这种复杂对象字段初始化一定为null,否则表单二次编辑填入数据会出问题
    numberOfInvestmentsLastFiveYear: null, // 注意这种复杂对象字段初始化一定为null,否则表单二次编辑填入数据会出问题
    knowledgeLevelOfDerivativesAndFunds: [],
  },
  fundSource: null, // 注意这种复杂对象字段初始化一定为null,否则表单二次编辑填入数据会出问题
};

// 单选框自定义渲染组件类型
// 这里新增定义之后,一定要添加到 CUSTOM_RADIO_OTHER_VALUES中
export const CUSTOM_RADIO_WITH_INPUT = "otherInput";
export const CUSTOM_RADIO_WITH_SELECT = "radioWithSelect";
// 在校验数据的时候排除掉表单选项的other选项标识
export const CUSTOM_RADIO_OTHER_VALUES = [CUSTOM_RADIO_WITH_INPUT, CUSTOM_RADIO_WITH_SELECT];

// kyc 信息模板下载地址 注意:文件地址结尾添加时间戳参数,是为了防止浏览器在下载(或者预览)文件的时候出现缓存(iOS出现过)
// 个人模板地址
export const KYC_TEMPLATE_URL_INDIVIDUAL = `https://aspen-prod.oss-ap-southeast-1.aliyuncs.com/afront/kyc-templates/self_certification_form_individual.docx?time=${new Date().getTime()}`;
// 机构模板地址
export const KYC_TEMPLATE_URL_ENTITY = `https://aspen-prod.oss-ap-southeast-1.aliyuncs.com/afront/kyc-templates/self_certification_form_entity.docx?time=${new Date().getTime()}`;

// 屏幕宽高（APP使用）
export const SCREEN_WIDTH = Dimensions.get("window").width;
export const SCREEN_HEIGHT = Dimensions.get("window").height;

//一个空的数组,用来给kyc表单的选项或者value数组作为默认值,使用常量是防止那些组件每次接收空数组([])都会导致render
export const EMPTY_ARRAY = [];

// 最新的kyc api版本
export const LATEST_KYC_API_VERSION: TKYCApiVersion = "V2";
